/**
 * Paper cut-outs of the hand-drawn illustrations, generated by
 * `pnpm gen:paper-cutouts` (scripts/gen-paper-cutouts.mjs) into
 * assets/images/paper/. Each cut-out is one main piece plus optional floating
 * pieces (e.g. the wizard cat's candles), positioned on a shared canvas.
 */
import manifest from '@app/assets/images/paper/cutouts.json';

const urls = import.meta.glob<string>('../assets/images/paper/*.webp', { eager: true, import: 'default' });

export type CutoutName = keyof typeof manifest;

export interface CutoutPart {
  url: string;
  /** Box on the cut-out canvas, in canvas px. */
  x: number;
  y: number;
  w: number;
  h: number;
  main: boolean;
  /** Topmost ink pixel — where a string would be tied. */
  anchor: { x: number; y: number } | null;
}

export interface Cutout {
  width: number;
  height: number;
  parts: CutoutPart[];
}

export function getCutout(name: CutoutName): Cutout {
  const entry = manifest[name];
  return {
    width: entry.width,
    height: entry.height,
    parts: entry.parts.map(p => ({ ...p, url: urls[`../assets/images/paper/${p.file}`] })),
  };
}

/** True when `value` names a generated cut-out (lets props accept a cut-out name or legacy emoji). */
export function isCutoutName(value: string | undefined): value is CutoutName {
  return !!value && Object.prototype.hasOwnProperty.call(manifest, value);
}
